/**
 * Collection page — shop-bar panels, filter drawer, view-column toggle.
 * El filtrado real es navegacion nativa (formularios/enlaces con
 * querystring); este script solo gestiona la UI que lo envuelve.
 */
(function () {
  'use strict';

  var grid = document.querySelector('[data-products-grid]');
  if (!grid) return;

  // ── Filter drawer ────────────────────────────────────────────────────────
  var drawer = document.querySelector('[data-filter-drawer]');
  var scrim = document.querySelector('[data-filter-drawer-scrim]');
  var drawerToggle = document.querySelector('[data-filter-drawer-toggle]');
  var drawerClose = document.querySelector('[data-filter-drawer-close]');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.inert = false;
    if (scrim) scrim.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.inert = true;
    if (scrim) scrim.hidden = true;
    document.body.style.overflow = '';
  }

  if (drawerToggle) drawerToggle.addEventListener('click', openDrawer);
  if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
  if (scrim) scrim.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  // Accordion sections inside the drawer
  document.querySelectorAll('[data-filter-section-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var section = btn.closest('[data-filter-section-wrap]');
      if (!section) return;
      var collapsed = section.classList.toggle('is-collapsed');
      btn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
    });
  });

  // Swatch selection toggles the checkbox it wraps
  document.querySelectorAll('.filter-swatch').forEach(function (swatch) {
    var input = swatch.querySelector('input[type="checkbox"]');
    if (!input) return;
    var sync = function () { swatch.classList.toggle('is-selected', input.checked); };
    input.addEventListener('change', sync);
    sync();
  });

  // ── Shop bar panels (category / sort) ───────────────────────────────────
  var barPanels = document.querySelectorAll('[data-bar-panel]');
  var barToggles = document.querySelectorAll('[data-bar-toggle]');

  function closeAllBarPanels() {
    barPanels.forEach(function (p) {
      p.classList.remove('is-open');
      p.setAttribute('aria-hidden', 'true');
      p.inert = true;
    });
    barToggles.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  }

  barToggles.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key = btn.getAttribute('data-bar-toggle');
      var panel = document.querySelector('[data-bar-panel="' + key + '"]');
      if (!panel) return;
      var isOpen = panel.classList.contains('is-open');
      closeAllBarPanels();
      if (!isOpen) {
        panel.classList.add('is-open');
        panel.setAttribute('aria-hidden', 'false');
        panel.inert = false;
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  document.addEventListener('click', function (e) {
    var wrap = document.querySelector('[data-shop-bar-wrap]');
    if (wrap && !wrap.contains(e.target)) closeAllBarPanels();
  });

  // Category panel — full navigation (each collection is its own URL)
  document.querySelectorAll('[data-bar-cat-link]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      window.location.href = btn.getAttribute('data-bar-cat-link');
    });
  });

  // Sort panel — navigate preserving existing filter querystring
  var sortInput = document.querySelector('[data-filter-sort-input]');
  document.querySelectorAll('[data-bar-sort]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var value = btn.getAttribute('data-bar-sort');
      if (sortInput) sortInput.value = value;
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', value);
      window.location.href = url.toString();
    });
  });

  // ── Hide bar when the footer scrolls into view ──────────────────────────
  var barWrap = document.querySelector('[data-shop-bar-wrap]');
  var footer = document.querySelector('.site-footer');
  if (barWrap && footer && 'IntersectionObserver' in window) {
    new IntersectionObserver(
      function (entries) {
        barWrap.classList.toggle('is-hidden', entries[0].isIntersecting);
      },
      { threshold: 0 }
    ).observe(footer);
  }

  // ── View column toggle (client-side only, saved preference) ────────────
  var viewToggle = document.querySelector('[data-view-toggle]');
  var MOBILE_KEY = 'vv_cols_mobile';
  var DESKTOP_KEY = 'vv_cols_desktop';

  // El `sizes` de cada imagen se renderiza en Liquid asumiendo 2 columnas
  // en mobile / 4 en desktop (ver product-card.liquid) — si el visitante
  // cambia a otra vista con este toggle, la imagen sigue ocupando el
  // hueco de esas columnas por defecto, y el navegador pide un candidato
  // del srcset pensado para un ancho mas pequeno del que realmente ocupa
  // (bug real: vista "1" en mobile se veia borrosa, el candidato era la
  // mitad de ancho de lo que la imagen mostraba a pantalla completa).
  function updateImageSizes() {
    var mobileCols = parseInt(grid.dataset.colsMobile, 10) || 2;
    var desktopCols = parseInt(grid.dataset.colsDesktop, 10) || 4;
    var sizes =
      '(min-width: 990px) ' + Math.ceil(100 / desktopCols) + 'vw, ' +
      Math.ceil(100 / mobileCols) + 'vw';
    grid.querySelectorAll('.product-card__slide-img').forEach(function (img) {
      img.sizes = sizes;
    });
  }

  function applyViewCols(cols, type) {
    if (type === 'mobile') {
      grid.dataset.colsMobile = cols;
      viewToggle.querySelectorAll('[data-view-mobile]').forEach(function (btn) {
        btn.classList.toggle('is-active', btn.dataset.viewMobile === cols);
      });
    } else {
      grid.dataset.colsDesktop = cols;
      viewToggle.querySelectorAll('[data-view-desktop]').forEach(function (btn) {
        btn.classList.toggle('is-active', btn.dataset.viewDesktop === cols);
      });
    }
    updateImageSizes();
  }

  if (viewToggle) {
    applyViewCols(localStorage.getItem(MOBILE_KEY) || '2', 'mobile');
    applyViewCols(localStorage.getItem(DESKTOP_KEY) || '4', 'desktop');

    viewToggle.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-view-mobile], [data-view-desktop]');
      if (!btn) return;
      if (btn.dataset.viewMobile) {
        applyViewCols(btn.dataset.viewMobile, 'mobile');
        localStorage.setItem(MOBILE_KEY, btn.dataset.viewMobile);
      } else {
        applyViewCols(btn.dataset.viewDesktop, 'desktop');
        localStorage.setItem(DESKTOP_KEY, btn.dataset.viewDesktop);
      }
    });
  }
})();
